import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#F06969"
        d="M4.159 7.351c-.734 0-1.334.6-1.334 1.333 0 .734.6 1.334 1.334 1.334.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333Zm8 0c-.734 0-1.334.6-1.334 1.333 0 .734.6 1.334 1.334 1.334.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.334-1.333Zm-4 0c-.734 0-1.334.6-1.334 1.333 0 .734.6 1.334 1.334 1.334.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.158.685h16v16h-16z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
